import { createSelector } from 'reselect';
const getPlaceholder = (state, props) => props.placeholder || props.defaultValue;
export default createSelector([getPlaceholder], placeholder => placeholder || '');